import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { TASK_INPUT_NAMES } from "constants/action-form";
import { FormSelectInput, FormTextInput } from "../../../form";
import NormalText from "../../Typography/NormalText";
import { actionInputName } from "../../action-modal/utils/inputName";

/**
 *
 * @param {Object} props
 * @param {import("constants/actions").Task} props.task - The task for which the quantity is being applied (e.g., "fertilize").
 * @param {boolean} props.isViewMode - Indicates if the input is in view mode (read-only).
 * @param {boolean} [props.isProposed] - Indicates if the input is for a proposed action.
 * @param {Array<{ value: string, label: string }>} props.quantityOptions - The options for quantity units.
 * @returns
 */
const QuantityInput = ({
  task,
  isProposed,
  isViewMode,
  quantityOptions = [],
}) => {
  const { t } = useTranslation();
  const { values } = useFormikContext();

  const taskInputName = TASK_INPUT_NAMES[task];
  const baseName = isProposed ? "proposedAction" : taskInputName;

  return (
    <div
      className={clsx("action-details-quantity-input", {
        "quantity-input-baseline": isViewMode,
      })}
    >
      {isViewMode ? (
        <NormalText
          text={values?.[baseName]?.quantity}
          sx={{ paddingLeft: "8px" }}
        />
      ) : (
        <FormTextInput
          name={actionInputName(taskInputName, "quantity", isProposed)}
          shouldHaveErrorBehaviorAfterSubmit
          sx={{
            width: "120px",
          }}
          isFullWidth={false}
          isViewMode={isViewMode}
        />
      )}
      <FormSelectInput
        name={actionInputName(taskInputName, "quantityUnits", isProposed)}
        placeholder={t("ActionModal.Units")}
        shouldHaveErrorBehaviorAfterSubmit
        options={quantityOptions}
        isViewMode={isViewMode}
        isFullWidth={false}
        sx={{ "& .select": { minWidth: "140px" } }}
      />
    </div>
  );
};

export default QuantityInput;
